import { useContext, useContextSelector } from 'use-context-selector';
import { AccountListContext } from './AccountListContext';

const useAccountListState = () => {
  const context = useContext(AccountListContext);

  if (context === undefined) {
    throw new Error('useAccountListState must be used within AccountListProvider');
  }

  return context;
};

const useAccountListAccounts = (limit?: number) => {
  const context = useContextSelector(AccountListContext, state => {
    if (limit && state.accountListData) {
      return { summary: state.accountListData?.summary, accounts: state.accountListData?.accounts?.slice(0, limit) };
    }
    return state.accountListData ?? { summary: null, accounts: [] };
  });

  if (context === undefined) {
    throw new Error('useAccountListAccounts must be used within AccountListProvider');
  }

  return context;
};

const useAccountListLoadingState = (loadingProperty: 'isLoadingAccounts') => {
  const context = useContextSelector(AccountListContext, state => state.loadingState);

  if (context === undefined) {
    throw new Error('useAccountListLoadingState must be used within AccountListProvider');
  }

  return context[loadingProperty];
};

const useAccountListErrorState = (errorProperty: 'accountsDataError') => {
  const context = useContextSelector(AccountListContext, state => state.errorState);

  if (context === undefined) {
    throw new Error('useAccountListErrorState must be used within AccountListProvider');
  }

  return context[errorProperty];
};

const useOnAccountListRefetch = () => {
  const context = useContextSelector(AccountListContext, state => state.onAccountListRefetch);

  if (context === undefined) {
    throw new Error('useOnAccountListRefetch must be used within AccountListProvider');
  }

  return context;
};

export {
  useAccountListState,
  useAccountListAccounts,
  useAccountListLoadingState,
  useAccountListErrorState,
  useOnAccountListRefetch,
};
